export const findMenuFromPath = (menuList, pathname) => {
  for (const parent of menuList) {
    // Parent has direct route
    if (parent.to === pathname) {
      return { parent, child: null };
    }

    // Parent has children
    if (parent.children) {
      for (const child of parent.children) {
        if (pathname.startsWith(child.to)) {
          return { parent, child };
        }
      }
    }
  }
  return { parent: null, child: null };
};
